module.exports = __webpack_public_path__ + "static/media/image_16.5b6d7b82.png";